import React from "react";
import { Control, Controller } from "react-hook-form";

import { Input, ErrorUI } from "@/components/Atoms";

import {
  InputGroupV2,
  InputWrapperV2,
  InputGroupV3,
  InputWrapperV3,
} from "../style";

interface EmailInputProps {
  name: string;
  control: Control<any>;
  emailPlaceholder: string;
  showLabels?: boolean;
  inputFontSize?: string;
  inputLineHeight?: string;
  isNotAbsolute?: boolean;
  handleBlur?: (e: any) => void;
  showIcon?: boolean;
  variant?: "v1" | "v2" | "v3";
}

const EmailInput: React.FC<EmailInputProps> = ({
  name,
  control,
  showLabels,
  emailPlaceholder,
  inputFontSize,
  inputLineHeight,
  handleBlur = () => {},
  isNotAbsolute,
  showIcon = false,
  variant = "v3",
}) => {
  const inputController = (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, onBlur, onChange, ref },
        fieldState: { error },
        formState: { errors },
      }) => (
        <>
          <Input
            ref={ref}
            type="email"
            name={name}
            placeholder={emailPlaceholder}
            value={value}
            onChange={onChange}
            onBlur={(e) => {
              e.persist();
              onBlur(e).then((e) => {
                if (!errors?.[name]) handleBlur(e);
              });
            }}
            autoComplete="off"
            icon={showIcon && "icon-EnvelopeSimple"}
            iconDimension="16px"
            variant={variant}
            inputFontSize={inputFontSize}
            inputLineHeight={inputLineHeight}
          />
          {error && (
            <ErrorUI
              hasBottomBorder
              error={error?.message}
              isNotAbsolute={isNotAbsolute}
            />
          )}
        </>
      )}
    />
  );

  if (variant === "v1") {
    return <></>;
  } else if (variant === "v2") {
    return (
      <InputWrapperV2>
        <InputGroupV2 hasBottomBorder showLabels={showLabels}>
          {inputController}
        </InputGroupV2>
      </InputWrapperV2>
    );
  } else {
    return (
      <InputWrapperV3>
        <InputGroupV3 hasBottomBorder showLabels={showLabels}>
          {inputController}
        </InputGroupV3>
      </InputWrapperV3>
    );
  }
};

export default EmailInput;
